import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center lh-primary"
}
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "value" }
const _hoisted_4 = { class: "label opacity05" }
const _hoisted_5 = { class: "value yellow" }
const _hoisted_6 = { class: "label opacity05" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  key: 0,
  class: "opacity05"
}
const _hoisted_10 = { key: 1 }

import {computed, getCurrentInstance, nextTick, ref} from 'vue';
import ReviewsFetcher, {ReviewsTotalInteface} from "~/chat/ts/service/reviews/ReviewsFetcher";
import IReview from "~/chat/ts/service/reviews/IReview";
import Review from "~/chat/vue/widget/tabs/reviews/Review.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import {REVIEW_PAGINATION_CLASSIC, REVIEW_PAGINATION_EXPAND} from "~/chat/ts/Constants";
import StringHelper from "~/ts/library/StringHelper";
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import {__} from "~/ts/library/Translate";
import {ConfigStore} from "~/chat/ts/store/Config";
import openReviewsTab from "~/chat/ts/service/api/methods/OpenReviewsTab";
import ReviewWrapper from "~/chat/vue/widget/tabs/reviews/ReviewWrapper.vue";


const __default__ = {
    name: "ReviewsList"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    onPage: { default: 10 },
    allSites: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    paginationType: { default: REVIEW_PAGINATION_EXPAND },
    displayName: { type: Boolean, default: true },
    displayCity: { type: Boolean, default: true },
    displayDate: { type: Boolean, default: true },
    displayRateValue: { type: Boolean, default: true },
    description: { type: Boolean, default: false },
    withReviewsDescription: {},
    withoutReviewsDescription: {},
    autoWidth: { type: Boolean, default: false },
    showTotal: { type: Boolean, default: true },
    inline: { type: Boolean },
    maxLength: {}
  },
  emits: ["scroll-to"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;


let page = ref(0);
let reviews = ref<IReview[]>([]);
let count = ref(0);
let total = ref<ReviewsTotalInteface>();

let canLoadMore = ref(false);
let loading = ref(false);

function showForm() {
    openReviewsTab(true);
}

let leaveReviewText = computed(() => {
    return ConfigStore.siteParams.value.params.rate.leaveRateButtonText;
});

function loadMore() {
    fetch();
}

function loadPrev() {
    page.value -= 2;
    fetch();
}

function openReviewForm() {
    openReviewsTab(true);
}

let instance = getCurrentInstance().proxy;

async function fetch() {
    canLoadMore.value = false;
    loading.value = true;
    let fetcher = (new ReviewsFetcher())
        .setAllSites(props.allSites)
        .setPage(page.value)
        .setOnPage(props.onPage);
    let result = await fetcher.fetch();
    total.value = result.total;
    loading.value = false;
    page.value++;
    if (props.paginationType == REVIEW_PAGINATION_CLASSIC) {
        reviews.value.splice(0, reviews.value.length);
    }
    reviews.value.push(...result.list);
    count.value = result.count;
    canLoadMore.value = result.count - page.value * fetcher.getOnPage() > 0;

    if (page.value > 1) {
        let height = (instance.$el as HTMLElement).offsetHeight;
        nextTick(() => {
            emits("scroll-to", height);
        });
    }
}


let descr = computed(() => {
    let result: string;
    if (props.description && (!loading.value || reviews.value.length)) {
        let link = `<a class='link-dashed' onClick="${ConfigStore.setup.value.apiMethod}('openReviewsTab', true); return false;" href="#">`;
        if (reviews.value.length) {
            var word = StringHelper.getSclon(
                count.value,
                __("OUR_VISITORS_RATE_1", count.value),
                __("OUR_VISITORS_RATE_2", count.value),
                __("OUR_VISITORS_RATE_3", count.value)
            );

            if (props.withReviewsDescription) {
                result = props.withReviewsDescription;
                result = result.split("{num}").join(count.value.toString()).split("{word}").join(word);
            }
        } else {
            result = props.withoutReviewsDescription ? props.withoutReviewsDescription : `
<p>${__("NO_RATES_NOW")}</p>
<p>${__("BE_FIRST", link, '</a>')}</p>
                    `;
        }
    }
    return result;
});

fetch();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(descr))
      ? (_openBlock(), _createBlock(Htmlify, {
          key: 0,
          value: _unref(descr),
          escape: false,
          class: "description",
          tag: "div"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (!_unref(loading) && !_unref(reviews).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_unref(__)("NO_RATES_NOW")) + " ", 1),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ChatFormButton, {
              type: "primary",
              onClick: showForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(leaveReviewText)), 1)
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.showTotal && _unref(total) && _unref(total).totalCount)
            ? (_openBlock(), _createBlock(ReviewWrapper, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass({'total d-flex text-center': true, inline: _ctx.inline})
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(total).totalCount), 1),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)("RATE_COUNT")), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(__)("S_FROM_S", (_unref(total).averageScore / 20).toFixed(2), 5)), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(__)("AVERAGE_RATE")), 1)
                    ]),
                    (_ctx.inline)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(ChatFormButton, {
                            type: "primary",
                            onClick: showForm,
                            inverse: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(leaveReviewText)), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
                'auto-width': _ctx.autoWidth,
                'reviews-list': true
            })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reviews), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "flex-fill"
              }, [
                _createVNode(Review, {
                  review: item,
                  "display-city": _ctx.displayCity,
                  "display-name": _ctx.displayName,
                  "display-date": _ctx.displayDate,
                  "display-rate-value": _ctx.displayRateValue,
                  "max-length": _ctx.maxLength
                }, null, 8, ["review", "display-city", "display-name", "display-date", "display-rate-value", "max-length"])
              ]))
            }), 128))
          ], 2),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_Transition, {
              name: "fade",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(__)("REVIEWS_LOADING")), 1))
                  : (_ctx.pagination)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.paginationType === 'expand')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", {
                                class: _normalizeClass({'mb-4': !_ctx.inline})
                              }, [
                                (_unref(canLoadMore))
                                  ? (_openBlock(), _createBlock(ChatFormButton, {
                                      key: 0,
                                      onClick: loadMore,
                                      class: "w-100"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(__)("LOAD_MORE")), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 2),
                              (!_ctx.inline)
                                ? (_openBlock(), _createBlock(ChatFormButton, {
                                    key: 0,
                                    onClick: openReviewForm,
                                    type: "primary",
                                    class: "w-100"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(leaveReviewText)), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_unref(page) > 1)
                                ? (_openBlock(), _createBlock(ChatFormButton, {
                                    key: 0,
                                    onClick: loadPrev
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" ← " + _toDisplayString(_unref(__)("BACK")), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_unref(canLoadMore))
                                ? (_openBlock(), _createBlock(ChatFormButton, {
                                    key: 1,
                                    onClick: loadMore
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(__)("FORWARD")) + " → ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ], 64))
  ]))
}
}

})